import React, { useState } from "react";

import { DataTableDef, SelectionMode } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";
import { glossaryMessages } from "ui/screens/plex-dictionary/plex-dictionary.localization";

import { ITranslation } from "../TermDictionary.state";

import { TermDictionaryGridItem } from "./TermDictionaryGridItem";

export interface ITermDictionaryMonolingualGridProps {
  entries?: ITranslation[];
  colName?: string;
  keyword?: string;
  onSelectionChanged?: (items: ITranslation[]) => void;
}

export const TermDictionaryMonolingualGrid: React.FC<ITermDictionaryMonolingualGridProps> = ({ entries, colName, keyword, onSelectionChanged }) => {
  const localizedValues = useLocalizedValues(() => ({
    placeholderColName: glossaryMessages.property("locale"),
    refineSearch: commonMessages.info("refineSearch"),
    startSearch: commonMessages.info("startSearch")
  }));
  const [selected, setSelected] = useState<ITranslation[]>([]);

  return (
    <DataTableDef<ITranslation>
      data={entries ? entries : []}
      keySelector={row => row.termId}
      selectionMode={SelectionMode.single}
      emptyText={entries ? localizedValues.refineSearch : localizedValues.startSearch}
      onSelectionChanged={items => {
        setSelected(items);
        onSelectionChanged && onSelectionChanged(items);
      }}
      selected={selected}
    >
      <DataTableDef.Column<ITranslation> id="translation" title={colName || localizedValues.placeholderColName} sortable valueSelector={row => row.translation}>
        {row => <TermDictionaryGridItem term={row.translation} definition={row.definition} keyword={keyword} />}
      </DataTableDef.Column>
    </DataTableDef>
  );
};
